import React from 'react';
import { __, validateForm } from '../core/utils';
import styles from '../styles/wizards/CreateFolderWizard.scss';
import FolderAddIcon from '../assets/images/folder-add-64x64.svg';
import { withRouter } from 'react-router';
import { setNotification } from '../redux/actions/general/notification';
import {
  createFolder,
  listFolders,
  updateFolder,
} from '../redux/actions/table/folders';
import CreateFolderForm from '../forms/create_folder_wizard/CreateFolderForm';

const CreateFolderWizard = ({
  match,
  onClose,
  parent_id,
  folder_id,
  title,
  onCreated,
}) => {
  const is_rename = !!folder_id;

  const _handleSubmit = (formData) => {
    return validateForm(
      (is_rename
        ? updateFolder(match.params.stage, folder_id, {
            title: formData.title,
          })
        : createFolder(match.params.stage, {
            title: formData.title,
            parent_id: parent_id || null,
          })
      ).then(() => {
        listFolders(match.params.stage);
        setNotification(
          is_rename ? __('Folder has been renamed.') : __('Folder has been created.')
        );
        if (onCreated) {
          onCreated();
        }
        onClose();
      })
    );
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{is_rename ? __('Rename folder') : __('Create folder')}</span>
          <span>
            {is_rename ? __('Edit folder name') : __('Add folder or sub-folder')}
          </span>
        </div>
        <div className={styles.right}>
          <FolderAddIcon />
        </div>
      </div>
      <div className={styles.body}>
        <CreateFolderForm
          onSubmit={_handleSubmit}
          onClose={onClose}
          submitLabel={is_rename ? __('button.save') : __('button.add')}
          initialValues={{
            title: title || '',
          }}
        />
      </div>
    </>
  );
};

export default withRouter(CreateFolderWizard);
